<template>
  <v-app>
    <v-main>
      <v-container fluid>
        <router-view />
      </v-container>
    </v-main>
    <snackbar />
    <loading />
  </v-app>
</template>

<script>
import Loading   from '../components/Loading'
import Snackbar  from '../components/Snackbar'
export default {
  name: 'App',
  components: {
    Loading,
    Snackbar,
  },
  data () {
    return {
      showSidebar: true,
      showHeader: true,
      showFooter: true,
    }
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
  },
}
</script>

<style lang="scss">
// グローバルスタイルを設定
#app {
  min-height: 100vh;
  background-color: #FAFAFA;
}
</style>
